<template>
  <b-taginput
      type="is-primary"
      v-model="selectedHorses"
      :data="filterHorses"
      :autocomplete="true"
      :open-on-focus="true"
      field="name"
      icon="label"
      placeholder="Selecciona multiples caballos"
      @typing="getFilteredHorses">
      <template slot-scope="props">
        <div :class="{'selected-tag': selectedHorses.find((x) => x.name === props.option.name) }">
          <strong>{{props.option.name}}</strong>
        </div>
      </template>
  </b-taginput>
</template>

<script>
import TenantService from '@/services/TenantService.js'

export default {
  props: {
    selected: {
      type: Array,
      required: false,
      default: () => []
    },
    lessonId: {
      required: true
    }
  },
  created () {
    this.getHorsesFromLessons()
  },
  data () {
    return {
      horses: [],
      filterHorses: [],
      selectedHorses: this.selected,
      isLoading: false
    }
  },
  methods: {
    getFilteredHorses (text) {
      this.filterHorses = this.horses.filter((option) => {
        return /* !this.selectedHorses.find((x) => x.name === option.name) && */ option.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0
      })
    },
    async getHorsesFromLessons () {
      if (this.lessonId === 0 || this.lessonId == null) {
        return false
      }
      this.isLoading = true
      let params = {
        lesson_id: this.lessonId
      }
      let response = await TenantService.getLessonComparison(params)
      this.horses = response.data.data
      this.filterHorses = this.horses
      this.isLoading = false
    }
  },
  watch: {
    lessonId (value) {
      this.selectedHorses = []
      this.getHorsesFromLessons()
    },
    selectedHorses (value) {
      this.$emit('update:selected', value)
    }
  }
}
</script>

<style scoped>
  div.selected-tag {
    color: #FF9800 !important;
  }
</style>
